import React from 'react'

const HeadingForm = ({ children, className = '' }) => {
    return (
        <div className={`heading-form heading-5 ${className}`}>
            <div className="heading-form__text">
                <b>{children}</b>
            </div>
        </div>
    )
}

export default HeadingForm
